import { render, staticRenderFns } from "./add-edit-employee.vue?vue&type=template&id=3f56a7c8&"
import script from "./add-edit-employee.vue?vue&type=script&lang=js&"
export * from "./add-edit-employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports